// NOTE: Make these values returned by functions to make them more testable (Cannot mock window.location.hostname/href unless we do this.)
const isRunningLocally = () => window.location.hostname === 'localhost'

const getBasePath = () => (isRunningLocally() ? '' : '/temple/guide-me')

const authFamilySearchBase = '/auth/familysearch/'

const getAuthBaseUrl = () => `${getBasePath()}${authFamilySearchBase}`

// Controls sign in URL to point to our app our Auth app.
// Our app is used for the Bishop's UX.
// Auth app is used for the regular member sign in.
const signInUrl = (isBishopSession) =>
  `${isBishopSession ? getAuthBaseUrl() : authFamilySearchBase}login?returnUrl=${encodeURIComponent(
    window.location.href
  )}`

// Just use our app for sign out regardless if its the bishop US because the behavior should be the same anyways
const signOutUrl = (returnUrl) => `${getAuthBaseUrl()}logout?returnUrl=${returnUrl}`

export { signInUrl, signOutUrl }
